






















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class blocMap extends Vue {
    // @Prop() private title!: string;

    @Prop() location
    @Prop() lift: 'oui' | 'non'
    @Prop() basement
    @Prop() mediumPrice
    @Prop() basementLevel
    @Prop() level

    get encodedMapLink(): string {
        if (this.location) {
            const mapLink = `https://www.google.com/maps/search/?api=1&query=${
                this.location
            }`
            const encodedMapLink = encodeURI(mapLink)
            return encodedMapLink
        }
        return ''
    }

    get basementLevelString(): string {
        if (this.basement && this.basementLevel) {
            return this.basementLevel > 1
                ? `, ${this.basementLevel} niveaux`
                : ', 1 niveau'
        }
        return ''
    }
}
